import React, { useState } from 'react';
import { DownloadIcon, SearchIcon, ChevronDownIcon } from 'lucide-react';
type BalanceType = 'Available' | 'Incoming' | 'Reserved' | 'On hold';
type ActivityType = 'Payment' | 'Reserve hold' | 'Refund' | 'Payout' | 'Fee' | 'Review hold';
interface ActivityEntry {
  effectiveDate: string;
  balanceType: BalanceType;
  activityType: ActivityType;
  description: string;
  reference: string;
  amountChange: number;
  runningBalance: number;
}
const balanceTypeColors: Record<BalanceType, string> = {
  Available: 'bg-green-500',
  Incoming: 'bg-amber-400',
  Reserved: 'bg-orange-400',
  'On hold': 'bg-red-400'
};
const allActivity: ActivityEntry[] = [{
  effectiveDate: '5 Dec 2025, 3:30 PM',
  balanceType: 'On hold',
  activityType: 'Review hold',
  description: 'High risk transaction review',
  reference: 'hld_1a',
  amountChange: 2500.0,
  runningBalance: 5500.0
}, {
  effectiveDate: '5 Dec 2025, 2:14 PM',
  balanceType: 'Available',
  activityType: 'Payment',
  description: 'Payment from Somchai Wattanachai',
  reference: 'ch_3Qx1a2',
  amountChange: 18500.0,
  runningBalance: 61767.25
}, {
  effectiveDate: '5 Dec 2025, 11:30 AM',
  balanceType: 'Available',
  activityType: 'Payment',
  description: 'Payment from Siriporn Trading',
  reference: 'ch_3Qx1b7',
  amountChange: 12450.8,
  runningBalance: 43267.25
}, {
  effectiveDate: '5 Dec 2025, 9:45 AM',
  balanceType: 'Incoming',
  activityType: 'Payment',
  description: 'Payment from Nattapong Wongsakul',
  reference: 'ch_3Qx1c4',
  amountChange: 8750.0,
  runningBalance: 3250.0
}, {
  effectiveDate: '4 Dec 2025, 4:30 PM',
  balanceType: 'Reserved',
  activityType: 'Reserve hold',
  description: '10% hold for ch_3Qx1c4',
  reference: 'rsv_hold_1',
  amountChange: 875.0,
  runningBalance: 12450.0
}, {
  effectiveDate: '4 Dec 2025, 2:00 PM',
  balanceType: 'On hold',
  activityType: 'Review hold',
  description: 'Unusual volume review',
  reference: 'hld_1b',
  amountChange: 3000.0,
  runningBalance: 3000.0
}, {
  effectiveDate: '4 Dec 2025, 10:15 AM',
  balanceType: 'Available',
  activityType: 'Refund',
  description: 'Refund to Nisa Cosmetics',
  reference: 're_1PxiVqJ',
  amountChange: -200.0,
  runningBalance: 30816.45
}, {
  effectiveDate: '3 Dec 2025, 2:00 PM',
  balanceType: 'Available',
  activityType: 'Payout',
  description: 'Payout to KASIKORNBANK •••• 1005',
  reference: 'po_10y2b3',
  amountChange: -29.52,
  runningBalance: 31016.45
}, {
  effectiveDate: '2 Dec 2025, 9:30 AM',
  balanceType: 'Available',
  activityType: 'Fee',
  description: 'Processing fee for ch_3Qx6a1',
  reference: 'fee_1Qz4c5',
  amountChange: -15.0,
  runningBalance: 31045.97
}, {
  effectiveDate: '2 Dec 2025, 8:00 AM',
  balanceType: 'Available',
  activityType: 'Payment',
  description: 'Payment from Bangkok Fresh Co.',
  reference: 'ch_3Qx5f2',
  amountChange: 5200.0,
  runningBalance: 31060.97
}, {
  effectiveDate: '1 Dec 2025, 4:45 PM',
  balanceType: 'Incoming',
  activityType: 'Payment',
  description: 'Payment from Pattaya Imports Ltd.',
  reference: 'ch_3Qx4e1',
  amountChange: 3800.0,
  runningBalance: 2500.0
}, {
  effectiveDate: '1 Dec 2025, 2:30 PM',
  balanceType: 'Available',
  activityType: 'Payout',
  description: 'Payout to KASIKORNBANK •••• 1005',
  reference: 'po_10y1a2',
  amountChange: -59.47,
  runningBalance: 25860.97
}, {
  effectiveDate: '1 Dec 2025, 10:00 AM',
  balanceType: 'Reserved',
  activityType: 'Reserve hold',
  description: '10% hold for ch_3Qx4e1',
  reference: 'rsv_hold_2',
  amountChange: 380.0,
  runningBalance: 11575.0
}, {
  effectiveDate: '30 Nov 2025, 3:15 PM',
  balanceType: 'Available',
  activityType: 'Payment',
  description: 'Payment from Chiang Mai Crafts',
  reference: 'ch_3Qx3d0',
  amountChange: 7250.0,
  runningBalance: 25920.44
}, {
  effectiveDate: '30 Nov 2025, 11:00 AM',
  balanceType: 'Available',
  activityType: 'Fee',
  description: 'Processing fee for ch_3Qx2c9',
  reference: 'fee_1Qz3b4',
  amountChange: -22.5,
  runningBalance: 18670.44
}, {
  effectiveDate: '29 Nov 2025, 5:30 PM',
  balanceType: 'Available',
  activityType: 'Refund',
  description: 'Refund to Siam Textiles',
  reference: 're_1Pxi2kL',
  amountChange: -450.0,
  runningBalance: 18692.94
}, {
  effectiveDate: '29 Nov 2025, 1:00 PM',
  balanceType: 'Available',
  activityType: 'Payment',
  description: 'Payment from Krabi Seafood Export',
  reference: 'ch_3Qx2c9',
  amountChange: 9500.0,
  runningBalance: 19142.94
}, {
  effectiveDate: '28 Nov 2025, 4:00 PM',
  balanceType: 'Incoming',
  activityType: 'Payment',
  description: 'Payment from Hua Hin Resort Group',
  reference: 'ch_3Qx1b8',
  amountChange: 15000.0,
  runningBalance: 1200.0
}, {
  effectiveDate: '28 Nov 2025, 10:30 AM',
  balanceType: 'Available',
  activityType: 'Payout',
  description: 'Payout to KASIKORNBANK •••• 1005',
  reference: 'po_10x9z1',
  amountChange: -35.47,
  runningBalance: 9642.94
}, {
  effectiveDate: '27 Nov 2025, 3:45 PM',
  balanceType: 'Available',
  activityType: 'Payment',
  description: 'Payment from Ayutthaya Antiques',
  reference: 'ch_3Qx0a7',
  amountChange: 4320.0,
  runningBalance: 9678.41
}, {
  effectiveDate: '27 Nov 2025, 9:15 AM',
  balanceType: 'Reserved',
  activityType: 'Reserve hold',
  description: '10% hold for ch_3Qx0a7',
  reference: 'rsv_hold_3',
  amountChange: 432.0,
  runningBalance: 11195.0
}, {
  effectiveDate: '26 Nov 2025, 2:00 PM',
  balanceType: 'Available',
  activityType: 'Fee',
  description: 'Processing fee for ch_3Qw9z6',
  reference: 'fee_1Qz2a3',
  amountChange: -18.75,
  runningBalance: 5358.41
}, {
  effectiveDate: '26 Nov 2025, 10:00 AM',
  balanceType: 'Available',
  activityType: 'Payment',
  description: 'Payment from Lopburi Farm Supply',
  reference: 'ch_3Qw9z6',
  amountChange: 2850.0,
  runningBalance: 5377.16
},
// Additional entries to reach 42 total
{
  effectiveDate: '25 Nov 2025, 4:30 PM',
  balanceType: 'Available',
  activityType: 'Refund',
  description: 'Refund to Phuket Dive Shop',
  reference: 're_1Pxh8mN',
  amountChange: -125.0,
  runningBalance: 2527.16
}, {
  effectiveDate: '25 Nov 2025, 11:15 AM',
  balanceType: 'Available',
  activityType: 'Payment',
  description: 'Payment from Koh Samui Tours',
  reference: 'ch_3Qw8y5',
  amountChange: 6100.0,
  runningBalance: 2652.16
}, {
  effectiveDate: '24 Nov 2025, 3:00 PM',
  balanceType: 'Available',
  activityType: 'Payout',
  description: 'Payout to KASIKORNBANK •••• 1005',
  reference: 'po_10x8y0',
  amountChange: -29.83,
  runningBalance: -3447.84
}, {
  effectiveDate: '24 Nov 2025, 9:00 AM',
  balanceType: 'Incoming',
  activityType: 'Payment',
  description: 'Payment from Udon Thani Electronics',
  reference: 'ch_3Qw7x4',
  amountChange: 11200.0,
  runningBalance: 950.0
}, {
  effectiveDate: '23 Nov 2025, 5:00 PM',
  balanceType: 'Reserved',
  activityType: 'Reserve hold',
  description: '10% hold for ch_3Qw7x4',
  reference: 'rsv_hold_4',
  amountChange: 1120.0,
  runningBalance: 10763.0
}, {
  effectiveDate: '23 Nov 2025, 1:30 PM',
  balanceType: 'Available',
  activityType: 'Payment',
  description: 'Payment from Nakhon Ratchasima Steel',
  reference: 'ch_3Qw6w3',
  amountChange: 8900.0,
  runningBalance: -3417.01
}, {
  effectiveDate: '22 Nov 2025, 4:15 PM',
  balanceType: 'Available',
  activityType: 'Fee',
  description: 'Processing fee for ch_3Qw5v2',
  reference: 'fee_1Qz1z2',
  amountChange: -31.25,
  runningBalance: -12317.01
}, {
  effectiveDate: '22 Nov 2025, 10:45 AM',
  balanceType: 'Available',
  activityType: 'Payment',
  description: 'Payment from Sukhothai Pottery',
  reference: 'ch_3Qw5v2',
  amountChange: 3450.0,
  runningBalance: -12285.76
}, {
  effectiveDate: '21 Nov 2025, 3:30 PM',
  balanceType: 'Available',
  activityType: 'Refund',
  description: 'Refund to Chiang Rai Coffee',
  reference: 're_1Pxg7lM',
  amountChange: -350.0,
  runningBalance: -15735.76
}, {
  effectiveDate: '21 Nov 2025, 9:00 AM',
  balanceType: 'Available',
  activityType: 'Payment',
  description: 'Payment from Lampang Ceramics',
  reference: 'ch_3Qw4u1',
  amountChange: 4750.0,
  runningBalance: -15385.76
}, {
  effectiveDate: '20 Nov 2025, 2:45 PM',
  balanceType: 'Available',
  activityType: 'Payout',
  description: 'Payout to KASIKORNBANK •••• 1005',
  reference: 'po_10x7x9',
  amountChange: -2624.57,
  runningBalance: -20135.76
}, {
  effectiveDate: '20 Nov 2025, 10:00 AM',
  balanceType: 'Incoming',
  activityType: 'Payment',
  description: 'Payment from Phitsanulok Furniture',
  reference: 'ch_3Qw3t0',
  amountChange: 7800.0,
  runningBalance: 800.0
}, {
  effectiveDate: '19 Nov 2025, 4:00 PM',
  balanceType: 'Reserved',
  activityType: 'Reserve hold',
  description: '10% hold for ch_3Qw3t0',
  reference: 'rsv_hold_5',
  amountChange: 780.0,
  runningBalance: 9643.0
}, {
  effectiveDate: '19 Nov 2025, 11:30 AM',
  balanceType: 'Available',
  activityType: 'Payment',
  description: 'Payment from Tak Border Trade',
  reference: 'ch_3Qw2s9',
  amountChange: 5600.0,
  runningBalance: -17511.19
}, {
  effectiveDate: '18 Nov 2025, 3:15 PM',
  balanceType: 'Available',
  activityType: 'Fee',
  description: 'Processing fee for ch_3Qw1r8',
  reference: 'fee_1Qz0y1',
  amountChange: -12.5,
  runningBalance: -23111.19
}, {
  effectiveDate: '18 Nov 2025, 9:45 AM',
  balanceType: 'Available',
  activityType: 'Payment',
  description: 'Payment from Mae Hong Son Trekking',
  reference: 'ch_3Qw1r8',
  amountChange: 2100.0,
  runningBalance: -23098.69
}, {
  effectiveDate: '17 Nov 2025, 4:30 PM',
  balanceType: 'Available',
  activityType: 'Refund',
  description: 'Refund to Nan Province Silk',
  reference: 're_1Pxf6kL',
  amountChange: -175.0,
  runningBalance: -25198.69
}, {
  effectiveDate: '17 Nov 2025, 10:00 AM',
  balanceType: 'Available',
  activityType: 'Payment',
  description: 'Payment from Phrae Teak Wood',
  reference: 'ch_3Qw0q7',
  amountChange: 6350.0,
  runningBalance: -25023.69
}, {
  effectiveDate: '16 Nov 2025, 2:30 PM',
  balanceType: 'Available',
  activityType: 'Payout',
  description: 'Payout to KASIKORNBANK •••• 1005',
  reference: 'po_10x6w8',
  amountChange: -29.52,
  runningBalance: -31373.69
}, {
  effectiveDate: '16 Nov 2025, 9:00 AM',
  balanceType: 'Incoming',
  activityType: 'Payment',
  description: 'Payment from Uttaradit Produce',
  reference: 'ch_3Qv9p6',
  amountChange: 4200.0,
  runningBalance: 650.0
}, {
  effectiveDate: '15 Nov 2025, 3:45 PM',
  balanceType: 'Available',
  activityType: 'Payment',
  description: 'Payment from Kamphaeng Phet Gems',
  reference: 'ch_3Qv8o5',
  amountChange: 9800.0,
  runningBalance: -31344.17
}];
const PAGE_SIZE = 7;
export function BalanceActivity() {
  const [searchQuery, setSearchQuery] = useState('');
  const [balanceFilter, setBalanceFilter] = useState('All balances');
  const [activityFilter, setActivityFilter] = useState('All activity');
  const [dateFilter, setDateFilter] = useState('Last 30 days');
  const [currentPage, setCurrentPage] = useState(1);
  const formatCurrency = (amount: number) => {
    return new Intl.NumberFormat('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(Math.abs(amount));
  };
  // Filter logic
  const filteredActivity = allActivity.filter(entry => {
    const matchesSearch = searchQuery === '' || entry.reference.toLowerCase().includes(searchQuery.toLowerCase()) || entry.description.toLowerCase().includes(searchQuery.toLowerCase());
    const matchesBalance = balanceFilter === 'All balances' || entry.balanceType === balanceFilter;
    const matchesActivity = activityFilter === 'All activity' || entry.activityType === activityFilter;
    return matchesSearch && matchesBalance && matchesActivity;
  });
  const totalEntries = filteredActivity.length;
  const totalPages = Math.ceil(totalEntries / PAGE_SIZE);
  const startIndex = (currentPage - 1) * PAGE_SIZE;
  const endIndex = Math.min(startIndex + PAGE_SIZE, totalEntries);
  const currentEntries = filteredActivity.slice(startIndex, endIndex);
  return <div className="max-w-7xl mx-auto" data-id="element-4803">
      {/* Header */}
      <div className="flex items-center justify-between mb-8" data-id="element-4804">
        <h1 className="text-3xl font-bold text-gray-900" data-id="element-4805">Balance activity</h1>
        <button className="flex items-center gap-2 px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors shadow-sm" data-id="element-4806">
          <DownloadIcon size={16} data-id="element-4807" />
          Export
        </button>
      </div>

      {/* Filters */}
      <div className="bg-white border border-gray-200 rounded-lg" data-id="element-4808">
        <div className="flex items-center gap-3 p-4 border-b border-gray-200" data-id="element-4809">
          {/* Search */}
          <div className="relative flex-1" data-id="element-4810">
            <SearchIcon size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" data-id="element-4811" />
            <input type="text" placeholder="Search by transaction ID, payout ID, order ref, dispute ref" value={searchQuery} onChange={e => {
            setSearchQuery(e.target.value);
            setCurrentPage(1);
          }} className="w-full pl-9 pr-4 py-2 text-sm border border-gray-200 rounded-lg bg-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-orange-500/20 focus:border-orange-400 transition-colors" data-id="element-4812" />
          </div>

          {/* Balance Type Filter */}
          <div className="relative" data-id="element-4813">
            <select value={balanceFilter} onChange={e => {
            setBalanceFilter(e.target.value);
            setCurrentPage(1);
          }} className="appearance-none pl-3 pr-8 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-200 rounded-lg cursor-pointer hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-orange-500/20 focus:border-orange-400 transition-colors" data-id="element-4814">
              <option data-id="element-4815">All balances</option>
              <option data-id="element-4816">Available</option>
              <option data-id="element-4817">Incoming</option>
              <option data-id="element-4818">Reserved</option>
              <option data-id="element-4819">On hold</option>
            </select>
            <ChevronDownIcon size={14} className="absolute right-2.5 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none" data-id="element-4820" />
          </div>

          {/* Activity Type Filter */}
          <div className="relative" data-id="element-4821">
            <select value={activityFilter} onChange={e => {
            setActivityFilter(e.target.value);
            setCurrentPage(1);
          }} className="appearance-none pl-3 pr-8 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-200 rounded-lg cursor-pointer hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-orange-500/20 focus:border-orange-400 transition-colors" data-id="element-4822">
              <option data-id="element-4823">All activity</option>
              <option data-id="element-4824">Payment</option>
              <option data-id="element-4825">Refund</option>
              <option data-id="element-4826">Payout</option>
              <option data-id="element-4827">Fee</option>
              <option data-id="element-4828">Reserve hold</option>
              <option data-id="element-4829">Review hold</option>
            </select>
            <ChevronDownIcon size={14} className="absolute right-2.5 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none" data-id="element-4830" />
          </div>

          {/* Date Filter */}
          <div className="relative" data-id="element-4831">
            <select value={dateFilter} onChange={e => {
            setDateFilter(e.target.value);
            setCurrentPage(1);
          }} className="appearance-none pl-3 pr-8 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-200 rounded-lg cursor-pointer hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-orange-500/20 focus:border-orange-400 transition-colors" data-id="element-4832">
              <option data-id="element-4833">Last 30 days</option>
              <option data-id="element-4834">Last 7 days</option>
              <option data-id="element-4835">Last 90 days</option>
              <option data-id="element-4836">This month</option>
              <option data-id="element-4837">Last month</option>
            </select>
            <ChevronDownIcon size={14} className="absolute right-2.5 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none" data-id="element-4838" />
          </div>
        </div>

        {/* Table */}
        <div className="overflow-x-auto" data-id="element-4839">
          <table className="w-full" data-id="element-4840">
            <thead data-id="element-4841">
              <tr className="border-b border-gray-200 bg-gray-50/50" data-id="element-4842">
                <th className="text-left px-5 py-3 text-xs font-semibold text-gray-500 uppercase tracking-wider" data-id="element-4843">
                  Effective date
                </th>
                <th className="text-left px-5 py-3 text-xs font-semibold text-gray-500 uppercase tracking-wider" data-id="element-4844">
                  Balance type
                </th>
                <th className="text-left px-5 py-3 text-xs font-semibold text-gray-500 uppercase tracking-wider" data-id="element-4845">
                  Activity type
                </th>
                <th className="text-left px-5 py-3 text-xs font-semibold text-gray-500 uppercase tracking-wider" data-id="element-4846">
                  Description
                </th>
                <th className="text-left px-5 py-3 text-xs font-semibold text-gray-500 uppercase tracking-wider" data-id="element-4847">
                  Reference
                </th>
                <th className="text-right px-5 py-3 text-xs font-semibold text-gray-500 uppercase tracking-wider" data-id="element-4848">
                  Amount change
                </th>
                <th className="text-right px-5 py-3 text-xs font-semibold text-gray-500 uppercase tracking-wider" data-id="element-4849">
                  Running balance
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100" data-id="element-4850">
              {currentEntries.map((entry, index) => <tr key={`${entry.reference}-${index}`} className="hover:bg-gray-50/50 transition-colors" data-id="element-4851">
                  <td className="px-5 py-4 text-sm text-gray-700 whitespace-nowrap" data-id="element-4852">
                    {entry.effectiveDate}
                  </td>
                  <td className="px-5 py-4 whitespace-nowrap" data-id="element-4853">
                    <div className="flex items-center gap-2" data-id="element-4854">
                      <div className={`w-2.5 h-2.5 rounded-full ${balanceTypeColors[entry.balanceType]}`} data-id="element-4855"></div>
                      <span className="text-sm text-gray-700" data-id="element-4856">
                        {entry.balanceType}
                      </span>
                    </div>
                  </td>
                  <td className="px-5 py-4 text-sm text-gray-700 whitespace-nowrap" data-id="element-4857">
                    {entry.activityType}
                  </td>
                  <td className="px-5 py-4 text-sm text-gray-700" data-id="element-4858">
                    {entry.description}
                  </td>
                  <td className="px-5 py-4 text-sm text-gray-500 font-mono whitespace-nowrap" data-id="element-4859">
                    {entry.reference}
                  </td>
                  <td className="px-5 py-4 text-sm font-medium text-right whitespace-nowrap" data-id="element-4860">
                    <span className={entry.amountChange >= 0 ? 'text-green-600' : 'text-gray-900'} data-id="element-4861">
                      {entry.amountChange >= 0 ? '+' : '-'}THB{' '}
                      {formatCurrency(entry.amountChange)}
                    </span>
                  </td>
                  <td className="px-5 py-4 text-sm text-gray-900 font-medium text-right whitespace-nowrap" data-id="element-4862">
                    THB {formatCurrency(entry.runningBalance)}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        <div className="flex items-center justify-between px-5 py-4 border-t border-gray-200" data-id="element-4863">
          <span className="text-sm text-gray-500" data-id="element-4864">
            Showing {startIndex + 1} to {endIndex} of {totalEntries} entries
          </span>
          <div className="flex items-center gap-2" data-id="element-4865">
            <button onClick={() => setCurrentPage(p => Math.max(1, p - 1))} disabled={currentPage === 1} className="px-3 py-1.5 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 disabled:opacity-40 disabled:cursor-not-allowed transition-colors" data-id="element-4866">
              Previous
            </button>
            <button onClick={() => setCurrentPage(p => Math.min(totalPages, p + 1))} disabled={currentPage === totalPages} className="px-3 py-1.5 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 disabled:opacity-40 disabled:cursor-not-allowed transition-colors" data-id="element-4867">
              Next
            </button>
          </div>
        </div>
      </div>
    </div>;
}